module.exports = __webpack_public_path__ + "static/media/3-cassv-reading-group-toolkit_shifting-from-carceral-to-tj-feminisms_final.81105d25.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/resources/pdf/3-cassv-reading-group-toolkit_shifting-from-carceral-to-tj-feminisms_final.pdf
// module id = 157
// module chunks = 0